import { jsxs, jsx } from 'react/jsx-runtime';

function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === 'function') {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
const TvIcon = (props)=>/*#__PURE__*/ jsxs("svg", _objectSpreadProps(_objectSpread({}, props), {
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        focusable: "false",
        children: [
            /*#__PURE__*/ jsxs("g", {
                clipPath: "url(#aa3e7131__clip0_20315_4851)",
                children: [
                    /*#__PURE__*/ jsx("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M1.0477 3.11551H14.7583C15.3369 3.11551 15.806 3.58458 15.806 4.16321V14.5298C15.806 15.1085 15.3369 15.5775 14.7583 15.5775H1.0477C0.46907 15.5775 0 15.1085 0 14.5298V4.16321C0 3.58458 0.46907 3.11551 1.0477 3.11551ZM2.82718 5.1925H10.6733C11.0876 5.1925 11.4235 5.52837 11.4235 5.9427V12.7503C11.4235 13.1647 11.0876 13.5006 10.6733 13.5006H2.82718C2.41285 13.5006 2.07697 13.1647 2.07697 12.7503V5.9427C2.07697 5.52837 2.41285 5.1925 2.82718 5.1925ZM13.1088 5.19248C13.4659 5.19248 13.7555 5.48203 13.7555 5.83921V10.7768C13.7555 11.1339 13.4659 11.4235 13.1088 11.4235C12.7516 11.4235 12.462 11.1339 12.462 10.7768V5.83921C12.462 5.48203 12.7516 5.19248 13.1088 5.19248ZM13.641 12.8409C13.641 13.2052 13.3457 13.5005 12.9813 13.5005C12.617 13.5005 12.3217 13.2052 12.3217 12.8409C12.3217 12.4765 12.617 12.1812 12.9813 12.1812C13.3457 12.1812 13.641 12.4765 13.641 12.8409Z",
                        fill: props.fill
                    }),
                    /*#__PURE__*/ jsx("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M11.8688 0.287993C12.0669 0.585182 11.9866 0.986715 11.6894 1.18484L8.15966 4.42285C7.94857 4.56358 7.6747 4.56788 7.45929 4.43387L4.1467 1.38988C3.84343 1.2012 3.75053 0.802392 3.93921 0.499117C4.12789 0.195842 4.52669 0.102943 4.82997 0.291622L7.78882 3.11554L10.972 0.108623C11.2692 -0.0895035 11.6707 -0.00919685 11.8688 0.287993Z",
                        fill: props.fill
                    })
                ]
            }),
            /*#__PURE__*/ jsx("defs", {
                children: /*#__PURE__*/ jsx("clipPath", {
                    id: "aa3e7131__clip0_20315_4851",
                    children: /*#__PURE__*/ jsx("rect", {
                        width: 15.22,
                        height: 15.4068,
                        fill: "white",
                        transform: "scale(1.0385)"
                    })
                })
            })
        ]
    }));
TvIcon.defaultProps = {
    width: 16,
    height: 16,
    fill: 'currentColor'
};

export { TvIcon as default };
//# sourceMappingURL=Tv.mjs.map
